import { Chart as ChartJS } from 'chart.js';

if (ChartJS.defaults.font) {
  ChartJS.defaults.font.family = '"Roboto Condensed", "Proxima Nova", Arial, sans-serif';
  ChartJS.defaults.font.size = 12;
}

if (ChartJS.defaults.elements) {
  if (ChartJS.defaults.elements.line) {
    ChartJS.defaults.elements.line.tension = 0.4;
    ChartJS.defaults.elements.line.borderWidth = 2;
  }
  if (ChartJS.defaults.elements.point) {
    ChartJS.defaults.elements.point.radius = 3;
    ChartJS.defaults.elements.point.hoverRadius = 5;
  }
}


